import { NgModule } from '@angular/core';
import { NglBadgesModule } from './badges/module';
import { NglBreadcrumbsModule } from './breadcrumbs/module';
import { NglButtonsModule } from './buttons/module';
import { NglDatatablesModule } from './datatables/module';
import { NglDatepickersModule } from './datepickers/module';
import { NglFormsModule } from './forms/module';
import { NglIconsModule } from './icons/module';
import { NglImagesModule } from './images/module';
import { NglLookupsModule } from './lookups/module';
import { NglMenusModule } from './menus/module';
import { NglModalsModule } from './modals/module';
import { NglNotificationsModule } from './notifications/module';
import { NglPaginationsModule } from './paginations/module';
import { NglPickModule } from './pick/module';
import { NglPicklistModule } from './picklist/module';
import { NglPillsModule } from './pills/module';
import { NglPopoversModule } from './popovers/module';
import { NglRatingsModule } from './ratings/module';
import { NglSectionsModule } from './sections/module';
import { NglSpinnersModule } from './spinners/module';
import { NglTabsModule } from './tabs/module';
import { NglConfig, NGL_CONFIG } from './config/config';
export { NglConfig } from './config/config';
var MODULES = [
    NglBadgesModule,
    NglBreadcrumbsModule,
    NglButtonsModule,
    NglDatatablesModule,
    NglDatepickersModule,
    NglFormsModule,
    NglIconsModule,
    NglImagesModule,
    NglLookupsModule,
    NglMenusModule,
    NglModalsModule,
    NglNotificationsModule,
    NglPaginationsModule,
    NglPickModule,
    NglPicklistModule,
    NglPillsModule,
    NglPopoversModule,
    NglRatingsModule,
    NglSectionsModule,
    NglSpinnersModule,
    NglTabsModule,
];
var NglModule = (function () {
    function NglModule() {
    }
    NglModule.forRoot = function (config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: NglModule,
            providers: [
                { provide: NGL_CONFIG, useValue: config },
                NglConfig,
            ],
        };
    };
    NglModule.decorators = [
        { type: NgModule, args: [{
                    exports: MODULES,
                },] },
    ];
    /** @nocollapse */
    NglModule.ctorParameters = function () { return []; };
    return NglModule;
}());
export { NglModule };
//# sourceMappingURL=ng-lightning.js.map